import React from 'react';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { closePopup } from 'app/redux/actions/PopupAlertActions'
import { useDispatch } from 'react-redux'
import useAuth from 'app/hooks/useAuth'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth:"500px",
    width: "100%",
    padding: "50px",
    fontSize: "20px"
  },  
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)

export const TimeoutWarningModal = ({isOpen, countdown, onRequestClose}) => {  

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { logout, user } = useAuth()

  const onLogOffCall = () => {
    // Implement your logout functionality here, e.g. clear the users login cache or hit your signout server
    // window.location.href = "https://www.google.com.my"
    // navigate('/account/signin')
    logout()
  }

  function handleClose() {
    dispatch(closePopup())
  }

  return (
    <div> 

      <Dialog
          open={isOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
      >
          <DialogTitle id="alert-dialog-title" sx={{ textTransform: 'capitalize' }}>
          Session Timeout
          </DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-description">
              You're being timed out due to inactivity. Please choose to stay signed in or to logoff. Otherwise, you will be logged off automatically in {countdown} second.
              </DialogContentText>
          </DialogContent>
          <DialogActions>

              <Button 
              // onClick={onLogOffCall}
              onClick={() => { onLogOffCall(); handleClose();}}
              >Log off</Button>

              <Button 
              // onClick={onRequestClose}
              onClick={() => { onRequestClose(); handleClose();}}
              >Stay Logged In</Button>

          </DialogActions>
      </Dialog>

    </div>  
  );
}

